// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchDesks_results__1-nRO","result":"SearchDesks_result__z1m4h","resultItem":"SearchDesks_resultItem__Meme4"};